import { useCallback } from 'react'
import { styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { t } from '$i18n'
import { SecondaryButton } from '$common/buttons'
import { BottomDrawer } from '$common/bottom-drawer'
import { showEnablePremiumFeaturesTrialConfirmModal } from '../confirmation-dialog/confirmation-dialog.api'

interface Props {
  isOpen: boolean
}

export function StartPremiumFeaturesTrial({ isOpen }: Props) {
  const handleClick = useCallback(async () => {
    await closeCurrentModal()
    void showEnablePremiumFeaturesTrialConfirmModal()
  }, [])

  return (
    <BottomDrawer onClose={closeCurrentModal} isOpen={isOpen} hidePuller>
      <Root>
        <Image
          alt={t('startPremiumFeaturesTrialModal.imageAlt')}
          src="/assets/images/enable-premium-features-demo.png"
          sx={{ mb: '32px' }}
        />
        <Typography
          variant="subtitle1"
          mb="48px"
          color="neutral900"
          textAlign="center"
        >
          {t('startPremiumFeaturesTrialModal.description')}
        </Typography>
        <SecondaryButton
          text={t('startPremiumFeaturesTrialModal.confirmText')}
          fullWidth
          onClick={handleClick}
        />
      </Root>
    </BottomDrawer>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`

const Image = styled('img')`
  width: 100%;
  display: block;
  max-width: 320px;
`
